const at = (point) => `${point.x.toFixed(1)},${point.y.toFixed(1)}`

// A monotone cubic through the points: the curve bends between days but can
// never rise above a peak or dip below a trough, so a smoothed line never
// invents a value the data does not have.
export function curvePath(points) {
  if (points.length < 2) return points.length ? `M${at(points[0])}` : ''
  if (points.length === 2) return `M${at(points[0])} L${at(points[1])}`

  const widths = []
  const slopes = []
  for (let index = 0; index < points.length - 1; index += 1) {
    const width = points[index + 1].x - points[index].x
    widths.push(width)
    slopes.push(width ? (points[index + 1].y - points[index].y) / width : 0)
  }

  const tangents = new Array(points.length)
  tangents[0] = slopes[0]
  tangents[points.length - 1] = slopes[slopes.length - 1]
  for (let index = 1; index < points.length - 1; index += 1) {
    const before = slopes[index - 1]
    const after = slopes[index]
    if (before * after <= 0) {
      tangents[index] = 0
      continue
    }
    const leftWeight = 2 * widths[index] + widths[index - 1]
    const rightWeight = widths[index] + 2 * widths[index - 1]
    tangents[index] = (leftWeight + rightWeight) / (leftWeight / before + rightWeight / after)
  }

  let path = `M${at(points[0])}`
  for (let index = 0; index < points.length - 1; index += 1) {
    const reach = widths[index] / 3
    const from = { x: points[index].x + reach, y: points[index].y + tangents[index] * reach }
    const to = { x: points[index + 1].x - reach, y: points[index + 1].y - tangents[index + 1] * reach }
    path += ` C${at(from)} ${at(to)} ${at(points[index + 1])}`
  }
  return path
}
